const getAttributionCategory = () => "see similar";

export default getAttributionCategory;
